export default __webpack_public_path__ + "static/media/chinmay.6fb08df1.jpeg";